/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Online_Cmp_Cli_DesktopInputs */

const en_pc_online_cmp_cli_desktop = /** @type {(inputs: Pc_Online_Cmp_Cli_DesktopInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Separate CLI download`)
};

const zh_pc_online_cmp_cli_desktop = /** @type {(inputs: Pc_Online_Cmp_Cli_DesktopInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`需单独下载 CLI`)
};

/**
* | output |
* | --- |
* | "Separate CLI download" |
*
* @param {Pc_Online_Cmp_Cli_DesktopInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_online_cmp_cli_desktop = /** @type {((inputs?: Pc_Online_Cmp_Cli_DesktopInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Online_Cmp_Cli_DesktopInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_online_cmp_cli_desktop(inputs)
	return zh_pc_online_cmp_cli_desktop(inputs)
});
export { pc_online_cmp_cli_desktop as "pc.online.cmp.cli.desktop" }